export enum UnderwritingDataProvider {
  BreatheLife = 'BreatheLife',
  ExamOne = 'ExamOne',
  Ingenium = 'Ingenium',
  IngeniumXML = 'IngeniumXML',
  LexisNexis = 'LexisNexis',
}
